import { motion } from "framer-motion";
import clsx from "clsx";

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

const container = {
  hidden: {},
  visible: { transition: { staggerChildren: 0.1 } },
};

export default function SectionHead({
  eyebrow,
  title1,
  titleGrad,
  title2,
  subtitle,
  className,
  maxWidth = "max-w-[720px]",
}) {
  return (
    <motion.div
      variants={container}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, amount: 0.4 }}
      className={clsx("mx-auto mb-14 text-center sm:mb-16 lg:mb-20", maxWidth, className)}
    >
      {eyebrow && (
        <motion.div
          variants={fadeUp}
          className="mb-4 text-[12px] font-extrabold uppercase tracking-[0.25em] text-teal-2 sm:text-[13px]"
        >
          {eyebrow}
        </motion.div>
      )}

      {(title1 || titleGrad || title2) && (
        <motion.h2
          variants={fadeUp}
          className="mb-4 text-[28px] font-black leading-[1.2] tracking-tight text-ink sm:text-[36px] lg:text-[46px]"
        >
          {title1 && <span>{title1} </span>}
          {titleGrad && (
            <span className="bg-gradient-to-br from-teal to-teal-2 via-gold-2 bg-clip-text text-transparent">
              {titleGrad}
            </span>
          )}
          {title2 && <span> {title2}</span>}
        </motion.h2>
      )}

      {subtitle && (
        <motion.p
          variants={fadeUp}
          className="mx-auto max-w-[560px] text-[15.5px] leading-[1.95] text-ink-soft sm:text-[16.5px]"
        >
          {subtitle}
        </motion.p>
      )}
    </motion.div>
  );
}